import { postListFetcher } from '@/shared/api/list';
import { GenericListPage } from '@/shared/ui/list/GenericListPage';
import type { ListPageConfig, ListRow } from '@/shared/ui/list/types';
import { markFilter, typeFilter } from './filters';

interface Generation extends ListRow {
  id: number;
  name?: string;
  model_name?: string;
  mark_name?: string;
}

const config: ListPageConfig<Generation> = {
  queryKey: 'car-generations',
  title: 'Справочник авто',
  boxTitle: 'Поколение',
  errorText: 'Ошибка загрузки поколений',
  fetchList: postListFetcher('/car/generation/list/'),
  rows: ['models'],
  searchKeys: [
    { value: 'id', label: 'Поиск по id' },
    { value: 'short_name', label: 'Поиск по поколению' },
  ],
  filters: [typeFilter, markFilter],
  columns: [
    { header: 'id', sortField: 'id', render: (generation) => generation.id },
    { header: 'Модель', sortField: 'name', render: (generation) => generation.model_name },
    { header: 'Марка', sortField: 'mark_id', render: (generation) => generation.mark_name || 'No mark' },
    {
      header: 'Поколение',
      sortField: 'type_id',
      render: (generation) => generation.name || 'No generation',
    },
  ],
};

export const GenerationsPage = () => <GenericListPage config={config} />;
